import { Middleware } from 'redux';
import { rcFormStateToKeyValue, config } from '@/utils';
import { getBook } from '@/selectors';
import { getStore, selectors } from '@lib/azgaz-ui/connect';
import { getSpecification } from '@azgaz/azgaz-ui';
import { actions, TFields } from '../store/book';

export const EVENT_ON_SUBMIT = 'carstockBookOnSubmit';

const onSubmitCallback = (fields: TFields) => {
  const readyFields: any = rcFormStateToKeyValue(fields);
  const connectStore = getStore();
  const connectState = connectStore.getState();
  const car = selectors.getCar(connectState);
  const onSubmit = config.get('onSubmit');

  if (car) {
    const { brand, model, specification, grade } = car;
    const [drive, transmission, engine] = [
      'drive',
      'transmission',
      'engine',
    ].map(i => getSpecification(specification, 'main', i) || '');

    const carInfo = [
      brand.toUpperCase(),
      model,
      engine,
      drive,
      transmission,
      grade,
    ].join(' ');

    readyFields.carInfo = carInfo;
  }

  if (typeof onSubmit === 'function') {
    onSubmit(readyFields);
  }

  document.dispatchEvent(
    new CustomEvent(EVENT_ON_SUBMIT, {
      detail: readyFields,
    })
  );
};

export const callbacksMiddleware: Middleware = store => next => action => {
  if (actions.bookingRequest.match(action)) {
    const { fields } = getBook(store.getState());
    onSubmitCallback(fields);
  }

  next(action);
};
